import { ArrowLeft } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Link to="/" className="inline-flex items-center gap-1 text-zinc-500 hover:text-white text-xs font-mono mb-6">
          <ArrowLeft size={14} /> Back
        </Link>
        <h1 className="text-3xl font-black mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>Terms of Service</h1>
        <div className="prose prose-invert prose-sm max-w-none space-y-4 text-zinc-300">
          <p><strong>Effective Date:</strong> {new Date().toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}</p>
          <p>These Terms of Service govern your use of Racing Form Guide, operated by RAW COMPANY TECH LIMITED (Company No. 17349121), registered in England & Wales.</p>
          <h2 className="text-white text-lg font-bold mt-6">1. Subscription & Payment</h2>
          <p>Access to Racing Form Guide requires a paid subscription of £9.99 per month. Payment is processed securely via Stripe. By subscribing, you authorise recurring monthly charges. You may cancel at any time.</p>
          <h2 className="text-white text-lg font-bold mt-6">2. Disclaimer of Odds</h2>
          <p><strong>The win chance percentages and odds displayed are calculated by RAW Company Tech's proprietary algorithm. They are NOT official bookmaker odds and should NOT be treated as such.</strong></p>
          <h2 className="text-white text-lg font-bold mt-6">3. No Gambling Advice</h2>
          <p>Racing Form Guide does not provide gambling advice. All information is for entertainment only. Please gamble responsibly. You must be 18+.</p>
          <h2 className="text-white text-lg font-bold mt-6">4. Limitation of Liability</h2>
          <p>RAW COMPANY TECH LIMITED shall not be liable for any losses arising from use of the Service.</p>
          <h2 className="text-white text-lg font-bold mt-6">5. Governing Law</h2>
          <p>These Terms are governed by the laws of England and Wales.</p>
          <h2 className="text-white text-lg font-bold mt-6">Contact</h2>
          <p>orders@rawcompanytech.com</p>
        </div>
        <div className="border-t border-zinc-800 mt-8 pt-4 text-[10px] text-zinc-600 text-center font-mono">
          &copy; {new Date().getFullYear()} RAW COMPANY TECH LIMITED &middot; Company No. 17349121
        </div>
      </div>
    </div>
  );
}
